<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalData"
      :modalData="modalData"
      :onModalClose="() => modalData = null"
      :onModalAccept="() => $refs.EditSupplier.save()"
    >
      <slot>
        <EditSupplier
          ref="EditSupplier"
          :supplier="modalData.supplier"
          :onSave="() => getRecords(paginator.current_page)"
        />
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-header">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
        <template v-if="!loading">
          <div class="text-right">
            <button type="button" @click="editSupplier({})" class="btn btn-outline-success">Новый поставщик</button>
          </div>
          <table class="table table-hover table-sm mt-1">
            <thead>
            <tr>
              <th></th>
              <th>Title</th>
              <th>Login URL</th>
              <th>Страна</th>
              <th>Max/уп</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, i) in records" :key="record.id">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ record.title }}</td>
              <td>{{ record.url }}
                <a :href="`${record.url}`" v-if="record.url" target="_blank"><i class="icon-fa icon-fa-globe"/></a>
              </td>
              <td>{{ countries[record.country_id] && countries[record.country_id].name }}</td>
              <td>{{ record.max_qty }}</td>
              <td>
                <template v-if="record.last_scan">
                  <p>{{ printDate(record.last_scan.updated_at, 'DD.MM.YYYY') }}</p>
                  <p>препаратов: <strong>{{ scanDrugs[record.id] ?? 0 }}</strong></p>
                </template>
              </td>
              <td>
                <LoadingButton
                  v-if="record.type_id === 1 && record.url"
                  title="парсить цены"
                  :loading="scanLoading[record.id]"
                  :color="$constants.PRIMARY_COLOR"
                  :onClick="() => scanSupplier(record)"
                  className="btn btn-outline-info btn-xs"
                />
              </td>
              <td>
                <button type="button" @click="editSupplier(record)" class="btn btn-default btn-xs">Редактировать
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      ref="Pagination"
                      :page-range="11"
                      :margin-pages="2"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import EditSupplier from "@/views/admin/invoices/components/EditSupplier";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    LoadingButton,
    Paginate,
    EmptyCardModal,
    EditSupplier,
  },
  data() {
    return {
      loading: true,
      records: null,
      paginator: null,
      countries: {},
      modalData: null,
      scanLoading: {},
      scanDrugs: {},
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    this.getRecords()
    this.countries = this.$AllCountries.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
  },
  methods: {
    async scanSupplier(record) {
      this.$set(this.scanLoading, record.id, true);
      const {data} = await api.post('/new/suppliers/scan', {
        supplier_id: record.id
      })
      if (data.success) {
        toastr['success']('Сканирование началось');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.scanLoading[record.id] = false;
    },
    editSupplier(record) {
      this.modalData = {
        supplier: record
      }
    },
    async getRecords(page = 1) {
      this.loading = true;
      this.modalData = null;
      let {data: r_data} = await api.index('/new/suppliers?page=' + page)
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.records = data;
        this.scanDrugs = {...this.scanDrugs, ...r_data.scanDrugs};
      } else {
        toastr['warning'](r_data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
